import "date-fns";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Circular from "../Circular/Circular";
import Table from "components/Table/Table";
import IconButton from "@material-ui/core/IconButton";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import { Refresh } from "@material-ui/icons";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import Visibility from "@material-ui/icons/Visibility";
import Icon from "@material-ui/core/Icon";
import LocalShipping from "@material-ui/icons/LocalShipping";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Button from "components/CustomButtons/Button.js";
import NewOrder from "./NewOrder";
import InfoOrder from "./InfoOrder";
import IntransitOrder from "./IntransitOrder";
import CancelOrder from "./CancelOrder";
import EditOrder from "./EditOrder";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardIcon from "components/Card/CardIcon.js";
import { getAllUsers, getMe } from "../../services/users/users";
import { getAllOrders, getAllActiveOrders, getAllOrdersFilter } from "../../services/orders/orders";
import ShowChartIcon from '@material-ui/icons/ShowChart';
import SearchIcon from '@material-ui/icons/Search';
import AllInbox from '@material-ui/icons/AllInbox';
import FormControl from "@material-ui/core/FormControl";
import PermanencyRate from "./PermanencyRate";
import SendAndCollect from "./SendAndCollect";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import ExportCsv from "exportCsv.js";
import Grid from '@material-ui/core/Grid';
import MomentUtils from "@date-io/date-fns";
import pt from "date-fns/locale/pt";
import { addHours, format } from 'date-fns'
import { api } from '../../services/api';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import Moment from "react-moment";
import moment from "moment";
import Confirm from "./Confirm";
import { getSlots } from "services/slots/slots";

Moment.globalMoment = moment;
Moment.globalLocale = "pt-br";
class Orders extends Component {
  constructor(props) {
    super(props);
    this.getOrders = this.getOrders.bind(this);
    this.createNewOrder = this.createNewOrder.bind(this);
    this.setDialog = this.setDialog.bind(this);
    this.setNotification = this.setNotification.bind(this);
    // this.setNotificationConfirm = this.setNotificationConfirm.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.cancelOrder = this.cancelOrder.bind(this);
    this.loadPage = this.loadPage.bind(this);
    this.getOrderById = this.getOrderById.bind(this);
    this.intransitOrder = this.intransitOrder.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChangeInit = this.handleDateChangeInit.bind(this);
    this.handleDateChangeFinal = this.handleDateChangeFinal.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChangeInit = this.handleChangeInit.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.openPermanencyRate = this.openPermanencyRate.bind(this);
    this.openSendAndCollect = this.openSendAndCollect.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.getUserLogged = this.getUserLogged.bind(this);
    this.updateOrderRabbit = this.updateOrderRabbit.bind(this);
    this.collectOrderRabbit = this.collectOrderRabbit.bind(this);
    this.setDialogUpdate = this.setDialogUpdate.bind(this);

    const dayMinus = new Date();
    // dayMinus.setDate(dayMinus.getDate() - 1);

    this.state = {
      circular: true,
      orders: [["Nenhuma encomenda encontrada!"]],
      statusO: false,
      selectedDateInit: dayMinus,
      selectedDateFinal: new Date(),
      dataExport: [{}],
      ordersH: [],
      locker: null,
      role: null,
      permanencyRate: false,
      sendAndCollect: false,
      statusesO: [
        {
          value: "reserved",
          label: "Reservada",
        },
        {
          value: "allocated",
          label: "Depositada",
        },
        {
          value: "expired",
          label: "Expirada",
        },
        {
          value: "collected",
          label: "Coletada",
        },
        {
          value: null,
          label: "-",
        }
      ],
      statuses: [
        [
          {
            "status": "addressed",
            "pt": "Reservada"
          },
          {
            "status": "reserved",
            "pt": "Reservada"
          },
          {
            "status": "allocated",
            "pt": "Depositada"
          },
          {
            "status": "collected",
            "pt": "Coletada"
          },
          {
            "status": "canceled",
            "pt": "Cancelada"
          },
          {
            "status": "pre_allocated",
            "pt": "Esperando baixa"
          },
          {
            "status": "allocatedClient",
            "pt": "Depositada"
          },
          {
            "status": "courrier_collected",
            "pt": "Coletada"
          },
          {
            "status": "expired",
            "pt": "Expirada"
          },
          {
            "status": "unableTocollect",
            "pt": "Encomenda presa"
          }
        ],
        [],
      ],
      openDialog: false,
      openUpdateDialog: false,
      editOrder: false,
      openSnackbar: false,
      success: "danger",
      message: "",
      messageUpdate: "",
      orderId: null,
      showInfo: false,
      showIntransit: false,
      awb: null,
      order: {},
      openCancel: false,
      search: false,
      dialogType: "",
      codeOrder: "",
      mapSlots: [],
      colorHeadCart: [
        "warning",
        "info",
        "success",
        "info",
        "warning",
        "danger",
      ],
    };
  }
  componentDidMount() {
    this.getUserLogged()
    this.getAllSlots()
    this.getLocker()
    // setTimeout(() => {
    //   this.getOrders(this.props.lockerId);
    // }, 1000);
  }

  getAllSlots = () => {
    const slotsArray = [];
    getSlots(this.props.lockerId, (slots) => {
      let mapSlots = new Map();
      slots.forEach(slot => {
        slotsArray.push({ "id": slot.id, "label": slot.label });
      });

      this.setState({ mapSlots: slotsArray });
    })
  }

  getLocker = () => {
    const urlTest = `/lockers/${this.props.lockerId}`;

    api.get(urlTest).then((res) => {
      console.log(res.data)
      this.setState({ locker: res.data.data });
    });
  }

  createNewOrder() {
    this.setState({ openDialog: true });
  }
  cancelOrder(order) {
    this.setState({ openCancel: true, order });
  }
  openEditOrder(order) {
    this.setState({ editOrder: true, order });
  }
  getOrderById(orderId, order) {

    console.log("ORDER", JSON.stringify(order));
    this.setState({ orderId, order, showInfo: true });
  }
  getUserLogged() {
    const user = JSON.parse(localStorage.getItem('user'));
    
    getMe((currentUser) => {
      if (currentUser && currentUser.roleName)
        this.setState({ role: currentUser.roleName });

      setTimeout(() => {
          this.getOrders(this.props.lockerId);
        }, 50);
    });

    // getAllUsers((users) => {
    //   if ((!users) || (users?.length == 0)) {
    //     // console.log("Current User Length", users?.length)
    //     return;
    //   }

    //   let currentUser = users.find(u => u.email === user.data.email);
    //   // console.log("Current User", currentUser)
    //   // console.log("Current User RoleName", currentUser.roleName)
    //   if (currentUser && currentUser.roleName) {
    //     this.setState({ role: currentUser.roleName });
    //   }

    //     setTimeout(() => {
    //       this.getOrders(this.props.lockerId);
    //     }, 50);
    // });
  }

  updateOrderRabbit(order) {
    console.log("ORDER", JSON.stringify(order));
    this.setState({ order, dialogType: "update", openUpdateDialog: true, messageUpdate: `Confirma o envio da encomenda no ${order.slot.label} (${order.type}) para o Locker?` });
  }

  collectOrderRabbit(order) {
    console.log("ORDER", JSON.stringify(order));
    this.setState({ order, dialogType: "collect", openUpdateDialog: true, messageUpdate: `Confirma a coleta da encomenda ${order.slot.label} em ${order.slot.label} (${order.type}) para o Locker?` });
  }

  formatDate(date) {
    let dateArray = date.split('T');
    let data = dateArray[0];
    let time = dateArray[1];

    let anoMesDia = data.split('-');
    let horaMinutos = time.substring(0, 5);

    return `${anoMesDia[2]}/${anoMesDia[1]}/${anoMesDia[0]} ${horaMinutos}`;
  }

  setDialogUpdate(openDialog) {
    this.setState({
      openUpdateDialog: openDialog,
      showInfo: openDialog,
      showIntransit: openDialog,
      openCancel: openDialog,
      editOrder: openDialog,
    });
  }

  handleChange(e) {
    let value = (e.target.value === '-') ? null : e.target.value;
    console.log(value)
    this.setState({ statusO: value });
  }

  // setNotificationConfirm(message, success, type) {
  //   console.log('entrou aqui');
  //   this.setState(
  //     {
  //       circular: true,
  //       messageUpdate: message,
  //       openUpdateDialog: true      
  //     },
  //     () => this.loadPage()
  //   );
  // }

  setDialog(openDialog) {
    this.setState({
      openDialog,
      showInfo: openDialog,
      showIntransit: openDialog,
      openCancel: openDialog,
      editOrder: openDialog,
    });
  }

  setNotification(message, success) {
    if (success === "success") {
      this.setState(
        {
          circular: true,
          message,
          success,
          openSnackbar: true,
          statuses: [
            [
              {
                "status": "addressed",
                "pt": "Reservada"
              },
              {
                "status": "reserved",
                "pt": "Reservada"
              },
              {
                "status": "allocated",
                "pt": "Depositada"
              },
              {
                "status": "collected",
                "pt": "Coletada"
              },
              {
                "status": "canceled",
                "pt": "Cancelada"
              },
              {
                "status": "pre_allocated",
                "pt": "Depositada"
              },
              {
                "status": "allocatedClient",
                "pt": "Depositada"
              },
              {
                "status": "courrier_collected",
                "pt": "Coletada"
              },
              {
                "status": "expired",
                "pt": "Expirada"
              },
              {
                "status": "unableTocollect",
                "pt": "Encomenda presa"
              }
            ],
            [],
          ],
        },
        () => this.loadPage()
      );
    } else {
      this.setState({ message, success, openSnackbar: true });
      setTimeout(() => {
        this.handleClose();
      }, 9000);
    }
  }

  loadPage() {
    this.componentDidMount();
    setTimeout(() => {
      this.handleClose();
    }, 9000);
  }

  handleClose() {
    this.setState({ openSnackbar: false });
  }

  openSearch() {
    let { search } = this.state;

    if (search) {
      this.resetSearch();
    }

    this.setState({ search: !search });
  }

  getOrders = (lockerId) => {
    getAllActiveOrders(
      lockerId,
      (data) => {
        this.buildOrdersTable(data);
      }
    );
  };

  buildOrdersTable = (data, filter = false) => {
    console.log("State Role", this.state.role);

    if (filter) {
      this.setState({ circular: true });
    }

    let { orders, statuses } = this.state;

    let dataExport = [];
    const classes = this.props.classes;
    
    if (!data.length > 0) {
      this.setState({ orders: [["Nenhuma encomenda encontrada!"]] });
      this.setState({ circular: false });
    } else {
      orders = data.length > 0 ? [] : orders
      data.forEach((order) => {
        let {
          id,
          slot,
          status,
          carrier,
          collectedAt,
          createdAt,
          allocatedAt,
          AWB,
          deliveryToken,
          condomino,
          externalOrderId,
          type
        } = order;

        // console.log(JSON.stringify(order));

        let diff;

        if (allocatedAt) {
          if (collectedAt) {
            diff = (Math.abs(new Date(collectedAt).getTime() - (new Date(allocatedAt)).getTime()) / 3600000).toFixed(2);
          } else {
            diff = (Math.abs(new Date().getTime() - addHours(new Date(allocatedAt), 3).getTime()) / 3600000).toFixed(2);
          }
          diff = `${String(diff).split('.')[0]}h${((Number(String(diff).split('.')[1]) / 100) * 60).toFixed(0)}min`;
        }


        orders.push([
          externalOrderId ? externalOrderId : '',
          condomino ? condomino.ala : "-",
          condomino ? condomino.bloco : "-",
          condomino ? condomino.ap : "-",
          condomino ? condomino.name : (order.receiverName && order.receiverName != 0) ? order.receiverName : '-',
          slot ? slot.label : "-",
          statuses[0].filter(st => st.status === status)[0].pt,
          (type == 'refund') ? "Devolução" : (type == 'change') ? "Troca" : "Entrega",
          (order.locker.lockerType == 'ecommerce' && order.type == 'delivery') ? "Agente" : (order.locker.lockerType != "ecommerce") ? "Correios" : "Cliente",
          diff ? diff : "-",
          createdAt ? (
            this.formatDate(createdAt)
          ) : (
            "-"
          ),
          allocatedAt ?
            this.formatDate(allocatedAt)
            : (
              "-"
            ),
          collectedAt ? (
            this.formatDate(collectedAt)
          ) : (
            "-"
          ),
          < div >
            {/* <IconButton
                  aria-label="view"
                  onClick={() => this.intransitOrder(AWB)}
                >
                  <LocalShipping className={classes.iconView} />
                </IconButton> */}
            {
              ['Administrador'].includes(this.state.role) &&
              <IconButton
                aria-label="view"
                onClick={() => this.openEditOrder(order)}
              >
                <Edit className={classes.iconView} />
              </IconButton>
            }
            <IconButton
              aria-label="view"
              onClick={() => this.getOrderById(id, order)}
            >
              <Visibility className={classes.iconView} />
            </IconButton>

            {order.status == 'reserved' ?
              <IconButton
                aria-label="view"
                onClick={() => this.cancelOrder(order)}
              >
                <Delete className={classes.iconView} />
              </IconButton>
              : ''
            }

            {
              ['Administrador'].includes(this.state.role) &&
              <IconButton
                aria-label="view"
                onClick={() => this.updateOrderRabbit(order)}
              >
                <CloudDownloadIcon className={classes.iconView} />
              </IconButton>
            }

            {
              (['Administrador'].includes(this.state.role) && ((order.status == 'allocated') || (order.status == 'collected'))) &&
              <IconButton
                aria-label="view"
                onClick={() => this.collectOrderRabbit(order)}
              >
                <PlaylistAddCheckIcon className={classes.iconView} />
              </IconButton>
            }
          </div >,
        ]);
        
        dataExport.push({
          "Codigo": externalOrderId ? externalOrderId : '',
          "Nome": condomino ? condomino.name : (order.receiverName && order.receiverName != 0) ? order.receiverName : '-',
          "Ala": condomino ? condomino.ala : "-",
          "Bloco": condomino ? condomino.bloco : "-",
          "Ap": condomino ? condomino.ap : "-",
          "Celular": order.receiverPhone ? order.receiverPhone : "-",
          "Email": order.receiverEmail ? order.receiverEmail : "-",
          "Codigo da Encomenda": deliveryToken ? deliveryToken : "-",
          "Label": slot ? slot.label : "-",
          "Status": statuses[0].filter(st => st.status === status)[0].pt,
          "Transportador": (status === "allocated" || status === "pre_allocated" || status === "addressed" || status === "reserved") ? "Correios" : status === "allocatedClient" ? "Cliente" : "-",
          "Permanencia": diff ? diff : "-",
          "Criada em": createdAt ? (`${this.formatDate(createdAt)}`) : ("-"),
          "Depositada em": allocatedAt ? (`${this.formatDate(allocatedAt)}`) : ("-"),
          "Coletada em": collectedAt ? (`${this.formatDate(collectedAt)}`) : ("-"),
          "Avaliação": order.surveyLocker?.nota,
          "PDF": order.pdfOrder?.pdf
        });
      });

      // statuses[0].forEach((st) => {
      //   let count = data.filter((sl) => sl.status === st.status).length;
      //   let statusString = "";
      //   switch (st.status) {
      //     /*case "not_addressed":
      //       statusString = "Não endereçado";
      //       break;*/
      //     case "addressed":
      //     case "reserved":
      //       statusString = "Reservado";
      //       break;
      //     case "allocated":
      //     case "pre_allocated":
      //       statusString = "Alocado";
      //       break;
      //     case "collected":
      //       statusString = "Coletado";
      //       break;
      //     case "canceled":
      //       statusString = "Cancelado";
      //       break;
      //   }
      //   statuses[1].push(` ${statusString}:${count} `);
      // });
      setTimeout(() => {
        console.log(orders)
        this.setState({ orders, statuses, circular: false, dataExport, ordersH: orders });
      }, 1000);
    }
  }
  intransitOrder(awb) {
    this.setState({ awb, showIntransit: true });
  }
  handleDateChangeInit(selectedDateInit) {
    this.setState({ selectedDateInit });
  }
  handleDateChangeFinal(selectedDateFinal) {
    this.setState({ selectedDateFinal });
  }
  handleExport = () => {
    const { dataExport } = this.state;
    ExportCsv(dataExport);
  };

  handleSearch = () => {
    const { codeOrder, statusO, selectedDateInit, selectedDateFinal } = this.state;
    console.log(codeOrder, statusO, selectedDateInit, selectedDateFinal)
    getAllOrdersFilter(
      this.props.lockerId, codeOrder, statusO, selectedDateInit, selectedDateFinal,
      // "&filter[$and][0][status][$ne]=collected&filter[$and][1][status][$ne]=courrier_collected&filter[$and][2][status][$ne]=canceled&[$ne]=canceled&include[0]=slot&include[1]=condomino&sort=createdAt",
      (data) => {
        console.log('getall')
        this.buildOrdersTable(data, true);
      }
    );

    // let { orders } = this.state;

    // if (codeOrder || statusO || selectedDateInit || selectedDateFinal)
    //   orders = ordersH;
    // orders = orders.filter(o => codeOrder ? o[0] === codeOrder : true);
    // orders = orders.filter(o => statusO ? o[5] === statusO : true);
    // orders = orders.filter(o => selectedDateInit ? new Date(o[8]).getTime() >= new Date(selectedDateInit).setHours(0, 0, 0, 0) : true);
    // orders = orders.filter(o => selectedDateFinal ? new Date(o[8]).getTime() <= new Date(selectedDateFinal).setHours(23, 59, 0, 0) : true);
    // if (!(orders.length))
    //   orders = [["Nenhuma encomenda encontrada!"]];
    // this.setState({ orders });
  }
  handleChangeInit = (event) => {
    this.setState({ codeOrder: event.target.value })
  }
  openPermanencyRate() {
    this.setState({ permanencyRate: true });
  }

  openSendAndCollect() {
    this.setState({ sendAndCollect: true });
  }
  resetSearch = () => {
    this.setState({ circular: true });
    this.componentDidMount();
    const { orders } = this.state;
    this.setState({ codeOrder: '', statusO: false, selectedDateInit: null, selectedDateFinal: null, ordersH: orders });
  }

  render() {
    const { circular, search, selectedDateInit, selectedDateFinal, codeOrder, statusO, permanencyRate, sendAndCollect } = this.state;
    const { classes } = this.props;
    let layout;

    layout = circular ? (
      <Circular />
    ) : (permanencyRate) ?
      <PermanencyRate lockerId={this.props.lockerId} /> : (sendAndCollect) ?
        <SendAndCollect lockerId={this.props.lockerId} /> : (
          <div>
            <div>
              <Button color="primary" onClick={() => this.createNewOrder()}>
                Criar Encomenda
              </Button>
            </div>
            {!search ? <div></div> : <h5>PESQUISAR ENCOMENDAS</h5>}
            <div className="up-buttons-order">
              {!search ?
                <Button color="primary" onClick={this.openSendAndCollect} ><ShowChartIcon /><span>Entregas e Retiradas</span></Button> :
                <FormControl
                  className={classes.green}
                >
                  <InputLabel htmlFor="slot">Código da Encomenda</InputLabel>
                  <Input
                    value={codeOrder}
                    onChange={this.handleChangeInit}
                    id="codeOrder"
                  />
                </FormControl>}
              {!search ?
                <div style={{ display: 'flex', flex: 1 }}></div> :
                <TextField
                  className={classes.green
                  }
                  select
                  label="Status Encomenda"
                  name="statusO"
                  value={statusO}
                  onChange={this.handleChange}
                >
                  {this.state.statusesO.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>}
              {!search ? <div></div> :
                <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      locale="pt"
                      variant="inline"
                      format="dd/MM/yyyy"
                      label="Data Inicial"
                      value={selectedDateInit}
                      onChange={this.handleDateChangeInit}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>}
              {!search ? <div></div> :
                <MuiPickersUtilsProvider utils={MomentUtils} locale={pt}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      locale="pt"
                      variant="inline"
                      format="dd/MM/yyyy"
                      label="Data Final"
                      value={selectedDateFinal}
                      onChange={this.handleDateChangeFinal}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>}
              {search ? <Button color="primary" onClick={this.handleSearch} ><span>PESQUISAR</span></Button> : <Button color="primary" onClick={() => this.openSearch()} ><SearchIcon /><span>Pesquisa</span></Button>}
            </div>
            {!search ? <div></div> : <div className="up-buttons-order">
              <div>
                <Button color="primary" onClick={() => this.openSearch()} ><span>Voltar</span></Button>
                <Button color="default" onClick={() => this.resetSearch()} ><span>Reset</span></Button>
              </div>
              <div></div>
              <div></div>
              <div></div>
              <Button onClick={this.handleExport} color="default">EXPORTAR</Button>
            </div>}
            <div>
              {/* <GridContainer spacing={10}>
              <GridItem xs={12} md>
                <Card className="locker-background">
                  <CardHeader className="locker-align-text" color="warning" stats icon>
                    <CardIcon className="locker-slots" color="info">
                      <AllInbox />
                    </CardIcon>
                    <h3 className={classes.cardTitle}>
                      {Number(this.state.statuses[1][0].split(':')[1])}
                    </h3>
                  </CardHeader>
                  <h4 className={classes.cardTitle}><p className="locker-padding">Encomendas endereçadas</p></h4>
                </Card>
              </GridItem>
              <GridItem xs={12} md>
                <Card className="locker-background">
                  <CardHeader className="locker-align-text" color="warning" stats icon>
                    <CardIcon className="locker-yellow locker-slots" color="info">
                      <AllInbox />
                    </CardIcon>
                    <h3 className={classes.cardTitle}>
                      {Number(this.state.statuses[1][1].split(':')[1])}
                    </h3>
                  </CardHeader>
                  <h4 className={classes.cardTitle}><p className="locker-padding">Encomenda reservadas</p></h4>
                </Card>
              </GridItem>
              <GridItem xs={12} md>
                <Card className="locker-background">
                  <CardHeader className="locker-align-text" color="success" stats icon>
                    <CardIcon className="locker-slots" color="success">
                      <AllInbox />
                    </CardIcon>
                    <h3 className={classes.cardTitle}>
                      {Number(this.state.statuses[1][2].split(':')[1])}
                    </h3>
                  </CardHeader>
                  <h4 className={classes.cardTitle}><p className="locker-padding">Encomenda depositadas</p></h4>
                </Card>
              </GridItem>
              <GridItem xs={12} md>
                <Card className="locker-background">
                  <CardHeader className="locker-align-text" color="warning" stats icon>
                    <CardIcon className="locker-slots" color="warning">
                      <AllInbox />
                    </CardIcon>
                    <h3 className={classes.cardTitle}>
                      {Number(this.state.statuses[1][3].split(':')[1])}
                    </h3>
                  </CardHeader>
                  <h4 className={classes.cardTitle}><p className="locker-padding">Encomenda coletadas</p></h4>
                </Card>
              </GridItem>
              <GridItem xs={12} md>
                <Card className="locker-background">
                  <CardHeader className="locker-align-text" color="danger" stats icon>
                    <CardIcon className="locker-slots" color="danger">
                      <AllInbox />
                    </CardIcon>
                    <h3 className={classes.cardTitle}>
                      {Number(this.state.statuses[1][4].split(':')[1])}
                    </h3>
                  </CardHeader>
                  <h4 className={classes.cardTitle}><p className="locker-padding">Encomenda canceladas</p></h4>
                </Card>
              </GridItem>
            </GridContainer> */}
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Código",
                  "Ala",
                  "Bloco",
                  "Ap",
                  "Destinatário",
                  "Porta",
                  "Status",
                  "Tipo",
                  "Entregador",
                  "Permanência",
                  "Criada em",
                  "Depositada em",
                  "Coletada em",
                  "Ações",
                ]}
                tableData={this.state.orders}
              />
              {this.state.openUpdateDialog ? (
                <Confirm
                  order={this.state.order}
                  lockerId={this.props.lockerId}
                  lockerName={this.state.lockerName}
                  open={this.state.openUpdateDialog}
                  message={this.state.messageUpdate}
                  type={this.state.dialogType}
                  setNotification={this.setNotification}
                  onChange={this.setDialogUpdate}
                />
              ) : null}
            </div>
          </div>
        );

    return (
      <div>
        {layout}
        {this.state.openDialog ? (
          <NewOrder
            lockerId={this.props.lockerId}
            locker={this.state.locker}
            slots={this.state.mapSlots}
            open={this.state.openDialog}
            setNotification={this.setNotification}
            onChange={this.setDialog}
          />
        ) : null}

        {this.state.showInfo ? (
          <InfoOrder
            open={this.state.showInfo}
            lockerId={this.props.lockerId}
            orderId={this.state.orderId}
            order={this.state.order}
            setNotification={this.setNotification}
            onChange={this.setDialog}
          />
        ) : null}
        {this.state.showIntransit ? (
          <IntransitOrder
            open={this.state.showIntransit}
            onChange={this.setDialog}
            setNotification={this.setNotification}
            awb={this.state.awb}
          />
        ) : null}
        {this.state.openCancel ? (
          <CancelOrder
            order={this.state.order}
            lockerId={this.props.lockerId}
            open={this.state.openCancel}
            setNotification={this.setNotification}
            onChange={this.setDialog}
          />
        ) : null}
        {this.state.editOrder ? (
          <EditOrder
            order={this.state.order}
            open={this.state.editOrder}
            setNotification={this.setNotification}
            onChange={this.setDialog}
          />
        ) : null}
        <Snackbar
          place="tc"
          color={this.state.success}
          icon={AddAlert}
          message={this.state.message}
          open={this.state.openSnackbar}
          closeNotification={this.handleClose}
          bodyStyle={{ height: 'auto', lineHeight: 28, padding: 24, whiteSpace: 'pre-wrap' }}
          close
        />
      </div>
    );
  }
}
export default withStyles(styles)(Orders);